// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vLob","colBig":"styles_colBig__2Bwr8","colSmall":"styles_colSmall__3l1Xj"};